<template>
  <div>
    <section role="form">
      <div class="main-container container">
        <div class="row">
          <div class="col-md-offset-2 col-md-8">
            <div class="card card-default card-final">
              <div class="card-content">
                <h4>
                  {{ titulo }}
                  <span v-if="cadastrado.mostraMultiplosRegistros">- {{ cadastrado.registro | formataRegistro }}</span>
                </h4>
                <div class="row row-field" v-if="cadastrado.ultimoProtocolo">
                  <p>
                    O presente <strong>protocolo</strong> serve apenas para
                    guarda <strong>pessoal</strong>, não sendo necessário a
                    entrega em nenhum setor da Prefeitura de Santos.
                  </p>
                  <p v-show="cadastrado.anexos.length === 0 &&
                    cadastrado.validacaoPendente === true
                    ">
                    Lembre-se de <strong>anexar</strong> seus documentos para
                    <strong>validar</strong> a atualização do seu cadastro.
                  </p>
                  <p>Anote ou imprima o seu número.</p>
                  <div class="espacado" style="color: #004f4a;">
                    <h2>PROTOCOLO</h2>
                    <h2 style="margin-top: 10px; padding-bottom: 10px;">
                      {{ cadastrado.ultimoProtocolo.codigo }}
                    </h2>
                  </div>
                </div>
                <div class="row row-field" v-else>
                  <div class="alert alert-warning espacado" role="alert" style="text-align: center; margin-top: 30px;">
                    <i class="fa fa-flag-o fa-lg"></i>&nbsp; Envie sua
                    atualização cadastral para receber um número de protocolo.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section role="controller" style="margin: 40px 15px; padding-bottom: 40px;">
      <botao estilo="cheio-verde-lg" rotulo="Imprimir" icone="fa-print" :disabled="!cadastrado.ultimoProtocolo"
        @clicado="imprime(cadastrado.id, cadastrado.ultimoProtocolo.id)" />
    </section>
  </div>
</template>
<script>
import Botao from '@/components/botao';
import ErrorHelper from '@/helpers/ErrorHelper';
import obtemImpressao from '@/services/obtemImpressao';

export default {
  name: 'Fim',

  data() {
    return {
      step: 7,
      cadastrado: this.$store.state.funcionarioCadastrado,
      apiErrors: null,
      titulo: "",
    };
  },

  methods: {
    chamaComponente(nomeComponente) {
      this.$router.push({ name: nomeComponente });
    },
    async imprime(id, protocolo) {
      const endpoint = `recadastramento-servidores/${id}/comprovantes/${protocolo}`;

      try {
        await obtemImpressao(endpoint);
      } catch (error) {
        const mensagem = ErrorHelper.trataMensagem(error);
        if (mensagem === 'Desbloqueie as pop-ups para este site') {
          this.$root.$refs.toastr.w(mensagem, 'Pop-up bloqueada');
        }
        this.$root.$refs.toastr.e(mensagem, 'Atenção');
      }
    },
  },

  mounted() {
    window.scrollTo(0, 0);
  },

  created() {
    this.$root.$data.stepNumber = this.step;
    if (this.cadastrado.mostraMultiplosRegistros) {
      this.$root.$refs.toastr.w(
        'Os dados do seu outro Registro serão atualizados automaticamente.',
        'Atenção',
      );
    }
    this.$eventBus.$on('salvaAvanca', nomeComponente => {
      this.chamaComponente(nomeComponente);
    });

    if (this.cadastrado && this.cadastrado.competencia) {
      this.titulo = `Atualização Cadastral ${this.cadastrado.competencia.ano}`;
    } else {
      this.titulo = "Atualização Cadastral"; // Valor padrão
    }
  },

  beforeDestroy() {
    this.$eventBus.$off('salvaAvanca');
  },

  components: {
    botao: Botao,
  },
};
</script>

<style scoped>
.card-content-end {
  padding-top: 5px;
  padding-bottom: 20px;
  text-align: center;
}

.espacado {
  text-align: center;
  margin: 44px 0 48px;
}

@media screen and (min-width: 768px) {
  .card-final {
    margin-top: 60px;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?6e17154e